import { Dispatch } from 'redux';
import { Action } from 'typescript-fsa';
import { SetIsAuthAction } from './actions';

export function setIsAuth(isAuth: boolean) {
    return (dispatch: Dispatch<Action<{}>>) => {
        dispatch(SetIsAuthAction(isAuth));
    }
}